$(function() {
    const iframeResize = {
        init() {
            iframeResize.create();
        },
        create() {
            var iframes = $('.copy iframe');
            if (iframes.length == 0) return;

            iframes.each(function() {
                var iframe = $(this);

                var wrapperDiv = $('<div class="iframe-wrapper"></div>');

                var iframeWidth = iframe.attr('width') || iframe[0].getBoundingClientRect().width;
                var iframeHeight = iframe.attr('height') || iframe[0].getBoundingClientRect().height;
                var aspectRatio = iframeWidth / iframeHeight;
                var paddingPercentage = 100 / aspectRatio;
                wrapperDiv.css('padding-bottom', paddingPercentage + '%');

                iframe.wrap(wrapperDiv);
            });
        }
    };

    iframeResize.init();
});